angular.module("app").controller("GamesReferencePageController", [
    '$scope',
    'preloadedSkins',
    'errorHandler',
    'casinoGameService',
    'logger',
    '$timeout',
    'preloadedCasinoSkins',
    '$filter',
    function ($scope, preloadedSkins, errorHandler, casinoGameService, logger, $timeout, preloadedCasinoSkins,$filter) {

        var pendingListRequest;
        var attached = [];
        var detached = [];
        $scope.filterOptions = {
            search: "",
            skinId: null,
            device: 'all',
            searchByExternal: ""
        };

        preloadedCasinoSkins.push({name: "Select Skin", id: null});

        $scope.casinoSkins = angular.copy(preloadedCasinoSkins);

        $scope.currentActiveSkin = null;

        $scope.skinsList = angular.copy(preloadedSkins);

        $scope.providers = [];

        var allProviders = [];


        $scope.existingQuery = "";

        $scope.skinsLimit = 0;

        $scope.filterForRemove = function (skin) {
            var item  = getItemFromList($scope.existingQuery, [skin]);
            return (item || item === null)
        };

        $scope.add = function (item) {
            $scope.currentActiveSkin = angular.copy(item);
            attached = [];
            detached = [];
            updateReferences($scope.currentActiveSkin.id,  !!getFiltersValues().m_skin_id ? getFiltersValues() : undefined)
        };

        $scope.toggleProviderGamesActivity = function (item, games) {
            for (var i = games.length; i--;) {
                var isNotChanged = games[i].switchEnabled === item.switchEnabled;
                games[i].switchEnabled = item.switchEnabled;

                $scope.setCurrentActive(games[i], games, item, item.switchEnabled, isNotChanged);
            }
        };

        $scope.handleSkinChange = function (skinId) {
            updateReferences($scope.currentActiveSkin.id, (!!getFiltersValues().search || !!getFiltersValues().m_skin_id) ? getFiltersValues() : undefined)
        };

        $scope.setCurrentActive = function (game, groupGames, groupsParent, forced, isNotChanged) {
            var attachedIndex = attached.indexOf(game.id);
            var detouchedIndex = detached.indexOf(game.id);
            if (!isNotChanged) {
                if (game.switchEnabled) {
                    if (detouchedIndex === -1) {
                        attached.push(game.id);
                    }
                    if (detouchedIndex !== -1){
                        detached.splice(detouchedIndex, 1);
                    }
                } else if (!game.switchEnabled) {
                    if (attachedIndex === -1) {
                        detached.push(game.id);
                    }
                    if (attachedIndex !== -1) {
                        attached.splice(attachedIndex, 1);
                    }
                }
            }


            var enabledCount = 0;
            for (var i = 0, length = groupGames.length; i < length; i++) {
                groupGames[i].switchEnabled && (enabledCount++);
            }
            groupsParent.switchEnabled = (enabledCount == length && enabledCount != 0) || !!forced

        };

        $scope.save = function () {
            if (detached.length === 0 && attached.length === 0) {
                return errorHandler($filter("translate")("Games not selected"));
            }

            casinoGameService.switchSkinsGames({switchSkinsGames: {attached: attached, detached: detached, skin_id: $scope.currentActiveSkin.id}}).then(
                function (response) {
                    if (response.status == "ok") {
                        detached = [];
                        attached = [];
                        logger.logSuccess("Data has been successfully saved");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )

        };

        $scope.refreshGamesList = function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);

            pendingListRequest = $timeout(function () {
                if ($scope.currentActiveSkin && $scope.currentActiveSkin.id) {
                    updateReferences($scope.currentActiveSkin.id, getFiltersValues())
                }
            }, 300)
        };

        function getFiltersValues() {
            var currentFilters = {};

            currentFilters = {
                m_skin_id: $scope.filterOptions.skinId
            };

            !currentFilters.search && (delete currentFilters.search);

            !currentFilters.m_skin_id && (delete currentFilters.m_skin_id);

            return currentFilters
        }

        function getItemFromList (filterQuery, list) {
            filterQuery = filterQuery.toLowerCase();
            if (!!filterQuery) {
                var length = list.length,
                i = 0;
                for (i, regex = new RegExp("^" + filterQuery);  i < length; i++) {
                    if ((list[i].name && regex.test(list[i].name.toLowerCase())) || regex.test(list[i].id)) {
                        return true
                    }
                }
            } else {
                return null
            }
            return false
        }

        function updateReferences (id, requestOptions) {
            var requestData = {skin_id: id};
            !!requestOptions && angular.extend(requestData, requestOptions);
            casinoGameService.getSkinProvidersGroups(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        allProviders = fetchData(angular.copy(response.groups), true);
                        $scope.searchGames();
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        }


        function checkGameName(game) {
            return game.name.toLowerCase().indexOf($scope.filterOptions.search.toLowerCase()) > -1;
        }

        function checkGameByExternalId(game) {
            return game.extearnal_game_id && game.extearnal_game_id.toString() === $scope.filterOptions.searchByExternal;
        }

        function checkDevice(game, device) {
            switch(device) {
                case 'all':
                    return true;
                case 'mobile':
                    return game.is_mobile == 1;
                case 'desktop':
                    return game.is_mobile == 0;
            }
        }


        $scope.searchGames = function searchGames() {
            if (!$scope.filterOptions.search && !$scope.filterOptions.searchByExternal && $scope.filterOptions.device === 'all') {
                $scope.providers = allProviders.slice();
                return;
            }

            var allProvidersLength = allProviders.length;
            var providers = [];
            for (var i = 0; i < allProvidersLength; ++i) {
                var provider = allProviders[i];
                var games = provider.games.filter(function (game) {
                    if ($scope.filterOptions.search && $scope.filterOptions.searchByExternal) {
                        return  checkGameName(game) && checkGameByExternalId(game) && checkDevice(game, $scope.filterOptions.device);
                    }else if ($scope.filterOptions.search) {
                        return checkGameName(game) && checkDevice(game, $scope.filterOptions.device);
                    } else if ( $scope.filterOptions.searchByExternal) {
                        return checkGameByExternalId(game) && checkDevice(game, $scope.filterOptions.device);
                    } else{
                        return checkDevice(game, $scope.filterOptions.device);
                    }
                });
                if (games.length > 0) {
                    var copyProvider = angular.copy(provider);
                    copyProvider.games = games;
                    providers.push(copyProvider);
                }
            }
            $scope.providers = providers;
        }

        function fetchData (data, initial) {

            for (var i = 0, iLength = data.length; i < iLength; i++) {
                if (data[i].hasOwnProperty('switchEnabled') && typeof data[i].switchEnabled == "string") {
                    data[i].switchEnabled = data[i].switchEnabled  == "0" ? false : (data[i].switchEnabled == "1" ? true : false);
                } else {
                    data[i].switchEnabled = !!data[i].switchEnabled || false
                }
                var enabledCount = 0;
                for (var j = 0, jLength = data[i].games.length; j < jLength; j++) {
                    if (data[i].games[j].hasOwnProperty('switchEnabled') && typeof data[i].games[j].switchEnabled == "string") {
                        data[i].games[j].switchEnabled = (data[i].games[j].switchEnabled == "0" ? false : (data[i].games[j].switchEnabled == "1" ? true : false));
                    } else {
                        data[i].games[j].switchEnabled = (!!data[i].games[j].switchEnabled || false) || currentEnabledIds.indexOf(data[i].games[j].id) != -1;
                    }
                    !!data[i].games[j].switchEnabled && (enabledCount++)

                }
                data[i].switchEnabled = enabledCount == jLength;

            }
            return data
        }

        /**
         * Check is one of childs has checked
         * @param item
         */
        $scope.checkChildren = function (item) {
            var isChecked = false;
            item.games.forEach(function (game) {
                if (game.switchEnabled) {
                    isChecked = true;
                    return;
                }
            });
            return isChecked;
        }

    }
]);
